module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - daedap2.4961de22.pdf";